export const ExtraSmall = {
  fontSize: {
    xs: '12px',
    lg: '14px',
    xl: '14px'
  },
  lineHeight: {
    xs: '18px',
    lg: '20px',
    xl: '22px'
  }
};